import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { FormikProps } from "formik";
import CustomSelect from "../../../../../components/CustomSelect";
import Text from "../../../../../components/Text";
import DeleteIcon from "../../../../../components/app/DeleteIcon";
import { Option } from "../../../../../constants/common";
import TimeSlotDropdown from "../../../../../constants/provider/InterdependentDropdowns";
import { SlotData } from "../../../../../constants/provider/availability";
import { NEW_APPOINTMENT_VISIT_TYPE_MAPPER } from "../../../../../constants/scheduling";
import Flex from "../../../../../components/Flex";

interface SlotCreationViewProps {
  formik: FormikProps<SlotData>;
  curDay: SlotData["daySlots"][number]["day"];
  onDeleteClick?: (curDaySlots: SlotData["daySlots"], ind: number) => void;
  locationList?: Option[];
}

const SlotCreationView = ({
  formik,
  curDay,
  locationList,
  onDeleteClick,
}: SlotCreationViewProps) => {
  // ? future reference
  // const { data: providerGroupLocationList } = useLocationsList({
  //   pagination: { page: 0, pageSize: 20 },
  //   providerGroupId: localStorage.getItem("realm"),
  // });

  // Get all slots for the current day
  const daySlots = formik.values?.daySlots?.filter(
    (slot) => slot.day === curDay
  );

  return daySlots?.map((dayData, index) => {
    // Calculate the original index of this slot in the daySlots array
    const originalIndex = formik.values.daySlots.findIndex(
      (slot) => slot === dayData
    );

    const startTimeError = (formik.errors.daySlots?.[originalIndex] as any)
      ?.startTime;
    const endTimeError = (formik.errors.daySlots?.[originalIndex] as any)
      ?.endTime;

    return (
      <Grid container spacing={2} key={index}>
        <Grid item xs={6}>
          <TimeSlotDropdown
            required
            startTime={dayData.startTime}
            endTime={dayData.endTime}
            setStartTime={(val) => {
              formik.setFieldValue(
                `daySlots[${formik.values.daySlots.findIndex(
                  (slot) => slot === dayData
                )}].startTime`,
                val
              );
            }}
            setEndTime={(val) => {
              formik.setFieldValue(
                `daySlots[${formik.values.daySlots.findIndex(
                  (slot) => slot === dayData
                )}].endTime`,
                val
              );
            }}
            startTimeError={startTimeError}
            endTimeError={endTimeError}
          />
        </Grid>
        <Grid item xs={3}>
          <Box width={"100%"}>
            <CustomSelect
              required={dayData.availabilityMode !== "VIRTUAL"}
              readOnly={dayData.availabilityMode === "VIRTUAL"}
              value={Object.keys(dayData?.location ?? {})[0]}
              label="Location"
              name="location"
              options={locationList}
              onChange={(val: any) => {
                formik.setFieldValue(
                  `daySlots[${formik.values.daySlots.findIndex(
                    (slot) => slot === dayData
                  )}].location`,
                  {
                    [val]: "",
                  }
                );
              }}
              error={(formik.errors.daySlots?.[originalIndex] as any)?.location}
            />
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Flex alignItems={"start"} justifyContent={"center"}>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ p: 0.5 }}
                  checked={dayData?.availabilityMode === "VIRTUAL"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      `daySlots[${formik.values.daySlots.findIndex(
                        (slot) => slot === dayData
                      )}].location`,
                      undefined
                    );
                    formik.setFieldValue(
                      `daySlots[${formik.values.daySlots.findIndex(
                        (slot) => slot === dayData
                      )}].availabilityMode`,
                      e.target.checked === true ? "VIRTUAL" : "IN_PERSON"
                    );
                  }}
                />
              }
              label={
                <Text>{NEW_APPOINTMENT_VISIT_TYPE_MAPPER["VIRTUAL"]}</Text>
              }
            />

            <DeleteIcon
              onClick={() => onDeleteClick?.(daySlots, originalIndex)}
              color={daySlots.length === 1 ? "default" : "error"}
            />
          </Flex>
        </Grid>
      </Grid>
    );
  });
};

export default SlotCreationView;
